
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'
import Panel from 'vux/src/components/panel/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'

import global from "../../../static/js/global.js";

export default {
data() {
return {
mtTitle: "",
notice: [],
pageNum: 1,
rows: 10,
lastNum: 0,
senTime: "",
redNums: "",
murs: false,
beginload: false,
list: [],
communityId: "",
content: []
};
},
components: {
Timeline,
TimelineItem,
LoadMore,
Flexbox,
FlexboxItem,
Panel,
Swiper
},
beforeMount() {
/*正式环境*/

let urlnotice =
global.host + "news/getNewsByTypeEqNotice?comnCode=" +
this.$router.history.current.query.communityId + "&pageNum=" +this.pageNum +"&rows=" +this.rows;
/*测试环境*/

this.communityId = this.$router.history.current.query.communityId;
let comnCode = this.communityId;
let openid = this.$router.history.current.query.openid;
let phone = this.$router.history.current.query.phone;
this.$http.get(urlnotice).then(
function(res) {
console.log(res);
if (res.body.result.size != 0) {
this.notice = res.body.result.list;

for (let i = 0; i < this.notice.length; i++) {
this.list[i] = new Object();
this.list[i].src = "../static/image/notice_pic.jpg";
this.list[i].title = this.notice[i].title;
this.list[i].url = "/notice_list?newid=" + this.notice[i].news_id + "&comnCode="+comnCode+"&phone="+phone+"&openid="+openid;
this.list[i].meta = new Object();
this.list[i].meta.date = this.notice[i].createTime;
}
this.beginload = true;
this.lastNum = res.body.result.size;
}
},
function(err) {

}
);
},
mounted() {
window.addEventListener("scroll", this.getMoreNotice);
if (this.$router.history.current.path == "/notice") {
document.title = "社区公告";
}
},
methods: {
getMoreNotice() {
/*正式环境*/
let urlnotice = global.host + "news/getNewsByTypeEqNotice?comnCode=" +this.$router.history.current.query.communityId + "&pageNum=" +this.pageNum + "&rows=" +this.rows;
/*测试环境*/

let trueH = window.innerHeight; 
let scrollH = window.scrollY; 
let totalH = document.getElementById("app").clientHeight; 
let shengyuH = totalH - trueH; 

let comnCode = this.$router.history.current.query.communityId;
let openid = this.$router.history.current.query.openid;
let phone = this.$router.history.current.query.phone;

if (scrollH >= shengyuH) {

if (this.lastNum == this.rows) {
this.$refs.lod.style.display = "block";
this.pageNum++;
console.log("滚动成功");
this.$http
.get(
global.host +
"news/getNewsByTypeEqNotice?comnCode=" +
this.$router.history.current.query.communityId +
"&pageNum=" +
this.pageNum +
"&rows=" +
this.rows
)
.then(
function(res) {
console.log("发送成功");
console.log(res);
let newData = res.body.result.list;
this.lastNum = res.body.result.size;
console.log(this.pageNum);
if (res.body.result.size == 0) {
/*阻止无用的请求*/
window.removeEventListener("scroll", this.getMoreNews);
return;
}
if (newData && newData.length > 0) {
let newNews = new Array();
for (let i = 0; i < newData.length; i++) {
newNews[i] = new Object();
newNews[i].src = "../static/image/notice_pic.jpg";
newNews[i].title = newData[i].title;
newNews[i].url = "/notice_list?newid=" + newData[i].news_id + "&comnCode="+comnCode+"&phone="+phone+"&openid="+openid;
newNews[i].meta = new Object();
newNews[i].meta.date = newData[i].createTime;
}
for (let j = 0; j < newNews.length; j++) {
this.list.push(newNews[j]);
this.$refs.lod.style.display = "none";
}
}
},
function(err) {
console.log(res);
}
);
} else {
console.log(this.lastNum);
this.$refs.lod.style.display = "none";
if (this.$refs.lod.style.display == "none") {
this.$refs.noS.style.display = "block";
}
return;
}
}
}
}
};



// WEBPACK FOOTER //
// ./src/components/newComponents/notice.vue